<div class="upload-progress-card">
  <div class="file-icon">
    <img src="assets/icons/file-upload-icon.svg" alt="File Upload" class="file-icon-img">
  </div>
  
  <div class="file-details">
    <div class="file-header">
      <span class="file-name">{{ fileName }}</span>
      <button class="delete-btn" (click)="onCancel()">
        <img src="assets/icons/bin-icon.svg" alt="Delete" class="bin-icon">
      </button>
    </div>
    
    <!-- <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill" [style.width.%]="progress"></div>
      </div>
    </div> -->
    
    <div class="file-footer">
      <span class="file-size">{{ fileSize }}</span>
      <!-- <span class="progress-percentage">{{ Math.round(progress) }}%</span> -->
    </div>
  </div>
</div>
